import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";

const SignaturePad = forwardRef(function SignaturePad({ height = 160 }, ref) {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const [empty, setEmpty] = useState(true);

  useEffect(() => {
    const c = canvasRef.current;
    const dpr = window.devicePixelRatio || 1;
    const w = c.parentElement.clientWidth;
    c.width = w * dpr;
    c.height = height * dpr;
    c.style.width = `${w}px`;
    c.style.height = `${height}px`;
    const ctx = c.getContext("2d");
    ctx.scale(dpr, dpr);
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, w, height);
    ctx.strokeStyle = "#1B1D23";
    ctx.lineWidth = 2.2;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
  }, [height]);

  const pos = (e) => {
    const r = canvasRef.current.getBoundingClientRect();
    return { x: e.clientX - r.left, y: e.clientY - r.top };
  };

  const start = (e) => {
    e.preventDefault();
    canvasRef.current.setPointerCapture(e.pointerId);
    drawing.current = true;
    const ctx = canvasRef.current.getContext("2d");
    const p = pos(e);
    ctx.beginPath();
    ctx.moveTo(p.x, p.y);
  };
  const move = (e) => {
    if (!drawing.current) return;
    const ctx = canvasRef.current.getContext("2d");
    const p = pos(e);
    ctx.lineTo(p.x, p.y);
    ctx.stroke();
    setEmpty(false);
  };
  const end = () => { drawing.current = false; };

  useImperativeHandle(ref, () => ({
    isEmpty: () => empty,
    toDataURL: () => canvasRef.current.toDataURL("image/png"),
    clear: () => {
      const c = canvasRef.current;
      const ctx = c.getContext("2d");
      ctx.save();
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, c.width, c.height);
      ctx.restore();
      setEmpty(true);
    },
  }), [empty]);

  return (
    <div className="w-full">
      <canvas ref={canvasRef} data-testid="signature-canvas"
              className="w-full rounded-xl border-2 border-dashed border-neutral-300 bg-white touch-none cursor-crosshair"
              onPointerDown={start} onPointerMove={move} onPointerUp={end} onPointerLeave={end} />
      {empty && <p className="text-[11px] text-neutral-400 mt-1 text-center">Dibuja aquí tu firma con el dedo o el ratón</p>}
    </div>
  );
});

export default SignaturePad;
